<template>
  <base-dropdown
    menu-on-left
    class="nav-item"
    tag="li"
    title-tag="a"
    title-classes="nav-link pr-0"
  >

  <badge circle class="mr-1" slot="title-container" :class="{
    'bg-success': alertCount === 0,
    'bg-warning': alertCount === 1,
    'bg-danger':  alertCount  >  1,
  }">
    {{ alertCount || ' ' }}
  </badge>
    <template>
      <div>
        <div class="dropdown-header noti-title">
          <h6 class="text-overflow m-0">Alertas Identificados</h6>
        </div>
        <div>
          <a v-for="alert in activeAlerts" :key="alert" @click.prevent class="dropdown-item">
            <badge class="badge-dot">
              <i class="bg-danger"></i>
            </badge>
            {{ ALERT_TRANSLATIONS[alert] }}
          </a>
        </div>
      </div>
    </template>
  </base-dropdown>
</template>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps(['alerts']);

const activeAlerts = computed(() => Object.keys(props.alerts).filter(key => props.alerts[key]));
const alertCount = computed(() => activeAlerts.value.length);

const ALERT_TRANSLATIONS = {
  "big_change_on_valor_meta": "Grande mudança na meta",
  "big_change_on_valor_estrategico": "Grande mudança no valor estratégico",
  "product_value_changed": "Valor do produto alterado",
}
</script>
